import React from "react";
import { GroupMemberPageView } from "./view";
import { GroupMemberPageController } from "./controller";
import { styles } from "./styles";

export class GroupMemberPage extends React.Component {
  controller = new GroupMemberPageController(this.props);

  render() {
    return (
      <GroupMemberPageView
        {...this.props}
        controller={this.controller}
        styles={styles}
      />
    );
  }
}
